import React, { useCallback, useEffect } from "react";
import { useState } from "react";
import styles from "../../styles/common/searchInput.module.css";
import debounce from "debounce";
import { SearchOutlined } from "@mui/icons-material";

type Props = {
  searchPage: Function;
  placeholder: string;
  error?: string | null;
};

const SearchInput = (props: Props) => {
  const [searchText, setSearchText] = useState<string>("");
  const [subscribe, setSubscribe] = useState(false);

  //eslint-disable-next-line
  const handleChange = useCallback(
    debounce((searchText: string) => {
      props.searchPage(searchText);
    }, 700),
    //eslint-disable-next-line
    []
  );

  useEffect(() => {
    subscribe && handleChange(searchText);

    setSubscribe(true);
    //eslint-disable-next-line
  }, [searchText]);

  return (
    <div className={styles.searchInput}>
      <button className={styles.searchIcon}>
        <SearchOutlined />
      </button>
      <input
        type="text"
        className={
          searchText === "" ? styles.searchField : styles.searchFieldOpen
        }
        placeholder="Type to Search..."
        value={searchText}
        onChange={(event) => setSearchText(event.target.value)}
        spellCheck={true}
      />
    </div>
  );
};

export default SearchInput;
